export default "__VITE_ASSET__CBaSp0Az__"